import { ChangeEvent, useCallback, useState } from "react";
import { debounce } from "./util";

interface FilterInputProps {
  onChange: (filter: string) => void;
}

const FilterInput = ({ onChange }: FilterInputProps) => {
  const [value, setValue] = useState<string>("");

  const debounceOnChange = useCallback(debounce(onChange, 500), []);

  const onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    debounceOnChange(newValue);
  };

  return <input value={value} onChange={onChangeInput}></input>;
};

export default FilterInput;
